import { addDays, todayCalendarDate } from '../../../../components/calendar/monthGrid';
import { uid } from '../../../../lib/uid';
import type { PressReleaseRequest } from '../pressReleaseTypes';

/**
 * A synthetic press release, for filling the form in one click.
 *
 * It lands in `rsys_` and names nobody — an announcement that read like a real one would be
 * indistinguishable from one later. The title is SUFFIXED so two samples can be told apart, and the
 * release date is a week out, so a sample never claims to have gone out already.
 */
export function samplePressRelease(): PressReleaseRequest {
  const suffix = uid().slice(0, 6).toUpperCase();

  return {
    title: `Sample press release ${suffix}`,
    releaseDate: addDays(todayCalendarDate(), 7),
    body: [
      `<h2>For immediate release</h2>`,
      `<p>Sample release ${suffix}. The organization announces the completion of a sample initiative.</p>`,
      `<h3>Highlights</h3>`,
      `<ul><li>The initiative was delivered on schedule.</li><li>Services remain available to the public.</li></ul>`,
      `<h3>Contact</h3>`,
      `<p>Public Relations Office — synthetic text written by Autogenerate.</p>`,
    ].join(''),
    // The form fills it from the LIVE list of cases this writer can open — a generator cannot know one.
    caseId: null,
  };
}
